import { isPreviouslyListed } from 'src/helpers/previouslyListedHomes';
import { createExperimentPage, disabledPage } from 'src/lib/flow/experimentPage';
import { FlowPage } from 'src/lib/flow/FlowPage';
import { CheckboxGroupQuestion } from 'src/lib/flow/FlowQuestion';
import { api } from 'src/store/api';

function isEnabled() {
  // Not Functional on this experimental page, passed for argument agreement
  // instead refer to async func in upgradesExperimentPage args
  return true;
}

function title(): string {
  return `Does your home have any of these features?`;
}

function subtitle() {
  return `Adding more info about your home helps us build a stronger offer.`;
}

const slug = () => 'interior-features';

const autoAdvance = () => true;

const interiorFeaturesPage: FlowPage = {
  slug,
  title,
  subtitle,
  isEnabled,
  autoAdvance,
  questions: (): CheckboxGroupQuestion[] => [
    {
      key: 'home.interior_features',
      type: 'multi_select',
      options: [
        { label: `Fireplace`, value: 'has_fireplace' },
        { label: 'Kitchen island', value: 'kitchen_island' },
      ],
      optional: true,
      showNoneOfTheAbove: true,
    },
  ],
};

const interiorFeaturesExperimentPage = createExperimentPage(
  'isPreviouslyListedExperimentFlag',
  {
    control: disabledPage('interior-features'),
    treatment: interiorFeaturesPage,
  },
  async (listenerApi) => {
    const appState = listenerApi.getState();
    const addressToken = appState.sellerInput.address.uuid;
    const { data } = await listenerApi.dispatch(api.endpoints.getValidata.initiate(addressToken));
    const confidenceData = data ?? [];

    const isPreviouslyListedResult = isPreviouslyListed(confidenceData);
    if (isPreviouslyListedResult) {
      return false;
    }
    return true;
  },
);

export default interiorFeaturesExperimentPage;
